import _ from "lodash";
import { popUp } from "../../../framework/controls/popUp";
import { buildValidationMessage } from "../../../framework/controls/validation";
import { alert } from "../../../framework/core/alert";
import * as dateUtil from "../../../framework/core/dateTime";
import { bind, observable } from "../../../framework/core/kendo";
import { ll, LocalizedLanguage } from "../../../framework/core/ll";
import { settings } from "../../../framework/core/settings";
import { getToken } from "../../../framework/core/token";
import { user } from "../../../framework/core/user";
import { emptyFn } from "../../../framework/core/util";
import { buildODataKendoParams } from "../../../framework/data/buildODataKendoParams";
import { codes } from "../../../framework/data/codes";
import { dataSource } from "../../../framework/data/dataSource";
import { searchTypes } from "../../../framework/data/searchTypes";
import { deleteEntity } from "../../../framework/dataComponents/deleteEntity";
import { searchPopUp } from "../../../framework/dataComponents/searchPopUp";
import { ajax } from "../ajax";
import * as layout from "../resizeWindow";
import { Component, Container, Grid, HTML, PaneIconLink } from "../ui";
import { Auth0Config, loadLanguageJSON } from "@msidata/zeact";
import enus from "../../../../Content/app/locale/en-us.json";
import engb from "../../../../Content/app/locale/en-gb.json";
import enza from "../../../../Content/app/locale/en-za.json";
import ennz from "../../../../Content/app/locale/en-nz.json";
import enau from "../../../../Content/app/locale/en-au.json";
import esmx from "../../../../Content/app/locale/es-mx.json";
import frca from "../../../../Content/app/locale/fr-ca.json";
import frfr from "../../../../Content/app/locale/fr-fr.json";
import jajp from "../../../../Content/app/locale/ja-jp.json";
import Axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { Appointment, Order, Specialty } from "@msidata/service-pro-api-schema";

export const calculateCookieExp = (): number => {
    const lsAuthResult = localStorage.getItem("authResult");
    const res = JSON.parse(lsAuthResult);
    const tokenPayload = res.accessTokenPayload;
    const exp = tokenPayload.exp;
    return exp - Math.floor((new Date()).valueOf() / 1000);
}

export const setCrossSubDomainCookie = (name: string, value: string, seconds: number, domain?: string): void => {
    const assign = `${name}=${escape(value)};`;
    const d = new Date();
    d.setTime(d.getTime() + seconds);
    const expires = `expires=${d.toUTCString()};`;
    const path = "path=/;"
    domain = domain || `domain=${location.hostname};`;
    document.cookie = `${assign} ${expires} ${path} ${domain}`;
}

export const usingAuth0 = (): boolean => window.z.configuration.auth0Enabled;

// returns true if user was authenticated using SSO
export const usingSso = (): boolean => {
    if (usingAuth0() && localStorage.authResult) {
        var authResult = JSON.parse(localStorage.authResult)

        if (authResult?.accessTokenPayload['https://servicepro10.com/sso']) {
            return true;
        }
    }
    return false;
}

export const getAuth0Config = (): Auth0Config => {
    const auth0Obj = window.z.configuration.auth0;
    const hasConfig = settings.brandName in auth0Obj;

    let config = auth0Obj;
    let auth0Config = null;

    if (!hasConfig) {
        auth0Config = _.extend(config, auth0Obj.servicepro);
    }
    else {
        auth0Config = _.extend(config, auth0Obj[settings.brandName])
    }

    // if a custom domain is specified, overwrite the default domain
    if (auth0Obj.customDomain) {
        auth0Config.domain = auth0Obj.customDomain;

        delete auth0Config.customDomain;
    }

    return auth0Config;
}

export const loadLanguage = (languageId?: string): void => {
    const lang = languageId === undefined
        ? "en-us"
        : languageId.toLowerCase();

    switch (lang) {
        case "en-gb":
            loadLanguageJSON(lang, engb);
            break;
        case "en-za":
            loadLanguageJSON(lang, enza);
            break;
        case "en-nz":
            loadLanguageJSON(lang, ennz);
            break;
        case "en-au":
            loadLanguageJSON(lang, enau);
            break;
        case "es-mx":
            loadLanguageJSON(lang, esmx);
            break;
        case "fr-ca":
            loadLanguageJSON(lang, frca);
            break;
        case "fr-fr":
            loadLanguageJSON(lang, frfr);
            break;
        case "ja-jp":
            loadLanguageJSON(lang, jajp);
            break;
        case "en-us":
        default:
            loadLanguageJSON(lang, enus);
            break;
    }
};

export const makeAPIClient = (configuration: { serviceProApiUrl: string }): AxiosInstance => {
    const client = Axios.create();
    const { serviceProApiUrl } = configuration;
    const requestConfig: AxiosRequestConfig = {
        baseURL: `${serviceProApiUrl}/service/api/`
    };

    Object.assign(client.defaults, requestConfig);

    const addHeaders = (config: AxiosRequestConfig) => {
        config.headers["Correlation-Id"] = config.headers["Correlation-Id"] || kendo.guid();
        config.headers["Client-Id"] = "sp10";
        const token = localStorage.getItem("IDSBearer")
        config.headers.Authorization = `Bearer ${token}`;

        return config;
    };

    client.interceptors.request.use(addHeaders);

    return client;
};

export function buildMediaUrl(media) {
    var urlPrefix = settings.appSettings.urlPrefix || "/service/api/";
    var token = getToken();
    var version = settings.companyVersion;

    return `${urlPrefix}Media?ʰ=${media}&ʱ=${token}&v=${version}`;
}

export function defaultLatLong() {
    return [user.companyData.Settings.Latitude, user.companyData.Settings.Longitude];
}

export function daysDiff(first, second) {
    return (second - first) / (1000 * 60 * 60 * 24);
}

export function buildFullName(first, last, defaultValue?) {
    if (first && last) {
        return `${first} ${last}`;
    }
    if (first) {
        return first;
    }
    if (last) {
        return last;
    }
    return defaultValue || null;
}

/*
* loadDeferredLink_Depricated
* takes in an observableobject and a path
*
* Usage
*    var billTo = deferredGet(customer, "BillTo");
*    var shipToNumber = deferredGet(customer, "BillTo.ShipTo.ShipToNumber");
*
*/
export function loadDeferredLink_Depricated(args) {
    var object = args.object,
        deferred = args.deferred,
        select = args.select,
        ignoreForUpdate = args.ignoreForUpdate == undefined ? true : args.ignoreForUpdate;

    var paths = deferred.split(".");

    $.each(paths, function (index, value) {
        var v = object && object[value];

        if (!v) {
            return false;
        }

        if (v.___deferred) {

            v = `/service${v.___deferred.uri}`;

            if (select) {
                if (v.indexOf("?") == -1) {
                    v += `?$select=${select}`;
                } else {
                    v += `&$select=${select}`;
                }
            }

            ajax({
                type: "GET",
                url: v,
                async: false
            }).done(function (data) {
                var ifu = false;
                if (ignoreForUpdate && args.screen && args.screen.workspace && args.screen.workspace.observables) {
                    ifu = true;
                    args.screen.workspace.observables.addIgnoreChangeForUpdate(value);
                }

                object[value] = data.d.results;

                if (ifu) {
                    args.screen.workspace.observables.removeIgnoreChangeForUpdate(value);
                }
            });
        }
        object = object[value];
        return true;
    });

    args.callback && args.callback();

    return object;
}

// This is used by the show/hide top banner on screens that have it:
export function getTextWidth(args) {

    $(document.body).append("<div id='Sizer'></div>");

    var sizer = $("#Sizer");
    var element: any;
    var size: number;

    if (args.element) {
        element = $(args.element);
    }

    sizer.text(args.value);

    if (args.fontSize) {
        size = args.fontSize;
    } else if (element) {
        element.css("font-size", "");
        size = parseInt(element.css("font-size"), 10);
    }

    sizer.css("font-size", size);
    var width = sizer.width();
    sizer.remove();

    return width;
}

export function validate(args) {
    var deferred = $.Deferred();

    if (args.validator.validate()) {
        deferred.resolve();
    } else {
        var validationMessage = buildValidationMessage(args.validator.validationErrors);
        alert({
            header: ll("ValidationIssues"),
            message: validationMessage,
            messageIsHTML: true,
            type: "danger"
        });
        args.e && args.e.preventDefault();
    }

    return deferred;
}

export function buildDeltaDate(deltaDate) {
    var utc = new Date(deltaDate.getTime() + deltaDate.getTimezoneOffset() * 60000);
    return utc.getFullYear() + "-" + dateUtil.zeroPad((utc.getMonth() + 1), 2) + "-" + dateUtil.zeroPad(utc.getDate(), 2) + "-" +
        dateUtil.zeroPad(utc.getHours(), 2) + "-" + dateUtil.zeroPad(utc.getMinutes(), 2) + "-" + dateUtil.zeroPad(utc.getSeconds(), 2);
}

export function getUrlParameter(paramName) {
    paramName = paramName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

    var regex = new RegExp("[\\?&]" + paramName + "=([^&#]*)");
    var results = regex.exec(location.search);

    if (results == null) {
        return "";
    }

    var result = $.trim(results[1]);
    return decodeURIComponent(result);
}

export function screenPopUp(args) {
    var screenName = args.name;
    var subScreen = args.subScreen;
    var actions = args.actions;
    var sPopUp = popUp({
        id: screenName,
        actions: actions,
        title: ll(screenName),
        width: args.width,
        close: function () {
            if (subScreen.unbindAll) {
                subScreen.unbindAll();
            }
        }
    });

    sPopUp.get(".popup-button-container").remove();

    sPopUp.guts.append(subScreen.container);
    var popUpWrapper = $("#" + sPopUp.screenId);
    popUpWrapper.find(".left-column").remove();
    popUpWrapper.find(".left-column-menu").remove();
    popUpWrapper.find(".sub-workspace").removeClass("container");
    popUpWrapper.find(".sub-workspace").removeClass("sub-workspace");
    subScreen.show();

    subScreen.width = $("#" + sPopUp.screenId).width();

    subScreen.initialize();

    var subScreenElem = $("#" + subScreen.screenId);
    subScreenElem.find(".left-column").remove();
    subScreenElem.find(".left-column-menu").remove();
    subScreenElem.find(".workspace").removeClass("content");
    subScreenElem.find(".workspace").removeClass("workspace");
    $(_.find(subScreenElem.find(".container"), function () { return true; })).removeClass("container");
    subScreenElem.find(".pane-field").removeClass("col-xs-6");
    subScreenElem.find(".pane-field").removeClass("col-md-4");
    subScreenElem.find(".pane-field").removeClass("col-lg-3");
    subScreenElem.find(".pane-field").addClass("col-xs-4");
    subScreenElem.find(".pane-container").addClass("mar-b-0 pad-b-0");
    subScreenElem.find(".pane-container:first").addClass("mar-t-20");
    subScreenElem.find(".pane").addClass("pad-b-0");

    $("#" + subScreen.screenId).find(".pane-field-text").addClass("mar-r-6");

    return sPopUp;
}

export function addSubScreen(screen, subScreen, args?) {
    screen.screenPosition = $("body").scrollTop();

    var existing = screen.subScreens[0];
    if (existing) {
        existing.destroy();
    }

    screen.add(subScreen);
    subScreen.initialize();

    screen.showSubWorkspace(args);
    subScreen.show();

    $(`#bc_${subScreen.screenId}`).tie("click", function (e) {
        var screenId = e.target.id.slice(3);

        var bcScreen = _.find(screen.subScreens as any[], function (sub) {
            return sub.screenId == screenId;
        });

        if (bcScreen.subScreens[0]) {
            bcScreen.subScreens[0].destroy();
        }

        bcScreen.workspace.show();
        bcScreen.toolbar.show();
        bcScreen.subWorkspace.hide();

        $(bcScreen).trigger("open");

        bcScreen.show();

        $("body").scrollTop(bcScreen.screenPosition);
    });

    if (screen.isSubScreen) {
        subScreen.toolbar.disableAll();
    }
    subScreen.isSubScreen = true;
    layout.resizeWindow();
    $(document).scrollTop(0);
}

function lowercaseFirstLetter(str) {
    if (window.z.debuggerAttached) {
        alert({
            type: "warning",
            header: "Deprecated",
            message: "lowercaseFirstLetter: This function is deprecated, please use String.toLowerCaseFirstLetter"
        });
    }
    console.log("This function is deprecated, please use String.toLowerCaseFirstLetter");
    return str.charAt(0).toLowerCase() + str.slice(1);
}

export function showSearchPopup(entityType, callback, searchType) {
    if (window.z.debuggerAttached) {
        alert({ type: "warning", header: "Deprecated", message: "showSearchPopup: This function is deprecated, please use z.controls.searchPopUp" });
    }
    console.log("This function is deprecated, please use z.controls.searchPopUp");

    searchType = searchType || searchTypes[lowercaseFirstLetter(entityType)]();
    callback = callback || emptyFn;

    var sPopUp = searchPopUp({
        id: entityType + "SearchPopup",
        title: ll(entityType),
        types: [
            searchType
        ],
        okClick: function () {
            var searchWindow = sPopUp.window;
            if (searchWindow.searchResults != null) {
                var result = searchWindow.searchResults;
                callback(result);
            }
        }
    });
}

export function addDefaults(args) {
    $.each($.parseJSON(localStorage.companyData).Default, function (index, item) {
        if (args.singleEntity) {
            if (item.EntityName == args.singleEntity) {
                if (item.Value == "True" || item.Value == "False") {
                    args.observable.set(item.Field, item.Value === "True");
                } else if (item.Value.indexOf(",") != -1) {
                    args.observable.set(item.Field, item.Value.split(","));
                } else {
                    args.observable.set(item.Field, item.Value);
                }
            }
        } else {
            $.each(args.entityList, function (ind, itm) {
                if (item.EntityName == itm) {
                    if (item.Value == "True" || item.Value == "False") {
                        args.observable.set(item.EntityName + item.Field, item.Value === "True");
                    } else if (item.Value.indexOf(",") != -1) {
                        args.observable.set(item.Field, item.Value.split(","));
                    } else {
                        args.observable.set(item.EntityName + item.Field, item.Value);
                    }
                }
            });
        }
    });
}

export function loadDefaults() {
    ajax({
        url: "User/GetDefaults",
        type: "GET"
    }).done(function (data) {
        var result = data.d.results;
        var temp = $.parseJSON(localStorage.companyData);
        temp.Default = result;
        localStorage.companyData = JSON.stringify(temp);
    });
}

export function updateDefaults(args: any) {
    let defaults = args.defaults,
        newDefaults = args.newDefaults;

    _.each(newDefaults, (newDef) => {
        let found = false;
        _.each(defaults, (def) => {
            if (def.Field == newDef.Field && def.EntityName == newDef.EntityName) {
                def.Value = newDef.Value + "";
                found = true;
            }
        });

        if (!found) {
            newDef.Value = newDef.Value + "";
            defaults.push(newDef);
        }
    });

    var temp = $.parseJSON(localStorage.companyData);

    temp.Default = defaults;
    localStorage.companyData = JSON.stringify(temp);

    return defaults;
}

export function showDocuments(args) {
    var id = args.id || args.observable.Id,
        entity = args.entity,
        readOnlyEntity = args.readOnlyEntity || null,
        readOnly = args.readOnly,
        title = args.title;

    var selectedDocument;
    var close = args.close;
    var documentPopUp = popUp({
        id: "DocumentPopUp",
        title: ll(title || "Documents"),
        close: close,
        classes: "mar-t-10",
        buttons: [
            {
                name: ll("Close"),
                className: "left"
            }
        ]
    });

    var components: Component[] = [];

    if (readOnlyEntity) {
        components.push(
            new Container({
                classes: "col-xs-12 row",
                components: [
                    new HTML({
                        HTML: "<ul id='DocFilter' class='mar-l-20 col-xs-1 mar-b-10 km-widget km-buttongroup'><li class='bind-label' id='" + entity + "Tab' data-bind='text: " + (args.entityTitle || entity) + "'></li><li class='bind-label' id='" + readOnlyEntity + "Tab' data-bind='text: " + readOnlyEntity + "'></li></ul>"
                    })
                ]
            })
        );
    }

    if (!readOnly) {
        components.push(new PaneIconLink({
            id: "Insert",
            bindLabel: "Insert",
            iconClass: "attachment",
            classes: "mar-l-10"
        }));
    }

    components.push(
        new Container({
            components: [
                new Grid({
                    containerClasses: "col-xs-8 no-pad",
                    id: "DocumentGrid",
                    stickyDefaultName: "DocumentGrid"
                }),
                new Container({
                    classes: "col-xs-4 no-pad",
                    id: "PreviewArea"
                })
            ]
        })
    );

    var guts = new Container({
        components: components
    });
    guts.options.zScreen = documentPopUp;
    guts.render(documentPopUp.guts);

    documentPopUp.get("#DocFilter").kendoMobileButtonGroup({
        index: 0
    });

    documentPopUp.index = 0;

    var switchGrids = function () {
        documentPopUp.get("#PreviewArea").empty();
        if (documentPopUp.index == 0) {
            documentPopUp.get("#Insert").show();
            documentPopUp.get("#DocumentGrid").data("kendoGrid").setDataSource(dataSource({
                transport: {
                    read: {
                        url: "" + entity + "Attachment",
                        dataType: "json"
                    },
                    parameterMap: function (data) {
                        return buildODataKendoParams({
                            data: data,
                            filterExpression: entity + "Id eq " + id,
                            selectExpression: "Attachment/FileName, Attachment/Description, Attachment/FilePath",
                            expandExpression: "Attachment"
                        });
                    }
                }
            }));

            documentPopUp.get("#DocumentGrid").data("kendoGrid").showColumn(2);
        } else {
            var readOnlyId = args.observable[readOnlyEntity + "Id"];
            documentPopUp.get("#Insert").hide();
            documentPopUp.get("#DocumentGrid").data("kendoGrid").setDataSource(dataSource({
                transport: {
                    read: {
                        url: "" + readOnlyEntity + "Attachment",
                        dataType: "json"
                    },
                    parameterMap: function (data) {
                        return buildODataKendoParams({
                            data: data,
                            filterExpression: readOnlyEntity + "Id eq " + readOnlyId,
                            selectExpression: "Attachment/FileName, Attachment/Description, Attachment/FilePath",
                            expandExpression: "Attachment"
                        });
                    }
                }
            }));
            documentPopUp.get("#DocumentGrid").data("kendoGrid").hideColumn(2);
        }
    };

    if (readOnlyEntity) {
        documentPopUp.get("#DocFilter").data("kendoMobileButtonGroup").bind("select", function (e) {
            documentPopUp.index = e.index;
            switchGrids();
            documentPopUp.get("#DocumentGrid").data("kendoGrid").dataSource.read();
        });
    }

    documentPopUp.get("#PreviewArea").on("click", ".link", function () {
        var fileName = selectedDocument.Attachment.FileName;
        documentPopUp.get("#PreviewArea").find(".link").disable();
        ajax({
            url: "Attachment/ActivateAttachment?id=" + selectedDocument.Attachment.Id,
            type: "GET",
            async: false
        }).done(function (response) {
            window.open(buildMediaUrl(response.d.results), fileName);
        }).always(function () {
            $.wait(500).then(function () {
                documentPopUp.get("#PreviewArea").find(".link").enable();
            });
        });
    });

    var documentGrid = documentPopUp.get("#DocumentGrid").data("me") as Grid;
    documentGrid.build({
        id: "DocumentGrid",
        zScreen: documentPopUp,
        entity: `${entity}Attachment`,
        expand: ["Attachment"],
        filter: `${entity}Id eq ${id}`,
        height: 228,
        selectable: "row",
        autoBind: false,
        columnOrder: ["Attachment/FileName", "Attachment/Description", "Attachment/DocumentType/Value"],
        deleteButton: !readOnly,
        change: function () {
            var theGrid = this;
            var row = theGrid.select().closest("tr");
            var dataItem = theGrid.dataItem(row);

            selectedDocument = dataItem;

            if (selectedDocument) {
                var fileName = dataItem.Attachment.FileName;
                var fileExtension = fileName.substr((fileName.lastIndexOf(".") + 1));
                var innerContent;

                ajax({
                    url: "Attachment/ActivateAttachment?id=" + dataItem.Attachment.Id,
                    type: "GET"
                }).done(function (response) {
                    if (fileExtension.isImgExtension()) {
                        innerContent = '<img src="' + buildMediaUrl(response.d.results) + '" class="resize-fit-center img-thumbnail">';
                        documentPopUp.get("#PreviewArea").html('<a target="_blank" class="link">' + innerContent + "</a>");
                    } else {
                        innerContent = "Attachment: " + dataItem.Attachment.FileName;
                        documentPopUp.get("#PreviewArea").html('<a target="_blank" href="' + buildMediaUrl(response.d.results) + '" class="link">' + innerContent + "</a>");
                    }

                    documentPopUp.get("#PreviewArea").html('<div class="attachment-container"><a target="_blank" class="link">' + innerContent + "</a></div>");
                });
            } else {
                documentPopUp.get("#PreviewArea").empty();
            }
        },
        dataBound: function (e) {
            var theGrid = this;

            var found = false;
            if (selectedDocument) {

                $.each(e.sender._data, function (index, data) {
                    if (selectedDocument.Id == data.Id) {
                        var uid = data.uid;

                        var row = theGrid.tbody.find('tr[data-uid="' + uid + '"]');

                        theGrid.select(row);
                        found = true;
                        return false;
                    }
                    return true;
                });
            }

            if (!found) {
                theGrid.select(e.sender.tbody.find("tr:first"));
            }
        }
    });

    documentGrid.refresh();

    documentPopUp.get("#Insert").tie("click", function () {
        uploadDocuments({
            Id: id,
            entity: entity,
            screen: documentPopUp
        });
    });

    documentPopUp.get("#DocumentGrid").on("click", ".k-grid-delete", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        deleteEntity({
            id: selectedDocument.Id,
            entity: entity + "Attachment",
            success: function () {
                documentPopUp.get("#DocumentGrid").data("kendoGrid").clearSelection();
                documentPopUp.get("#DocumentGrid").data("me").refresh();
            }
        });
    });

    bind({ container: "#" + documentPopUp.screenId, bind: ".bind-label", data: LocalizedLanguage });
}

export function uploadDocuments(args) {
    let Id = args.Id,
        entity = args.entity,
        sourceScreen = args.screen,
        successEntity = args.successEntity || "Attachment",
        urlPrefix = settings.appSettings.urlPrefix || "/service/api/",
        saveUrl = args.saveUrl || "Attachment/Upload/",
        gridId = args.gridId || "DocumentGrid",
        multiple = args.multiple === undefined ? true : args.multiple,
        success = args.success || emptyFn,
        complete = args.complete || emptyFn,
        hasDescription = args.hasDescription === undefined ? true : args.hasDescription,
        documentType = _.find(codes.DocumentType, (dt) => dt.CodeNumber === "USER DOCUMENT");

    let documentPopUp = popUp({
        id: "UploadPopup",
        classes: "note-popup",
        title: ll("UploadDocument"),
        buttons: []
    });

    documentPopUp.setGuts("<input type='file' name='files' id='" + documentPopUp.id + "_DocumentUpload' />");

    let template = `<div class='container full-width-container no-pad'>
    <div class='bold ellipsis col-xs-6 no-pad'>
        <div class='app-small-spinner left'></div>
        <div class='fas fa-check-circle left'></div>
        <div class='fas fa-exclamation-circle left'></div>
        <div class='left'>#=name#</div>
    </div>`;

    if (hasDescription) {
        template += `<span class='pane-field-label col-xs-5'>
        Description:
        <span style='position: relative; height: 26px; display: inline-block;'>
        <input style='width: 180px;' class='pane-field-input' type='text' autocomplete='no!' id='${documentPopUp.id}_#=files[0].uid#_AttachmentDescription'>
        <span class='required' style='margin-top: 3px;margin-right: 1px;'></span>
        </span>
        </span>
        </div>`;
    }

    documentPopUp.get("#DocumentUpload").kendoUpload({
        multiple,
        async: {
            saveUrl: `${urlPrefix}${entity}${saveUrl}${Id}${documentType ? `?documentTypeId=${documentType.Id}` : ""}`,
            autoUpload: false
        },
        upload: function (e) {
            let xhr = e.XMLHttpRequest,
                uid = e.files[0].uid;
            if (xhr) {
                xhr.addEventListener("readystatechange", function () {
                    if (xhr.readyState == 1 /* OPENED */) {
                        xhr.setRequestHeader("Authorization-Token", getToken());
                        xhr.setRequestHeader("Company-Version", settings.companyVersion);
                    }
                });

                if (hasDescription) {
                    let description = documentPopUp.get(`#${uid}_AttachmentDescription`).val();
                    if (!description || $.trim(description) == "") {
                        alert({ type: "danger", header: "Validation Error:", message: ll("AttachmentRequiredMessage") });
                        e.preventDefault();
                    } else {
                        e.data = { Description: description };
                    }
                } else {
                    e.data = { Description: e.files[0].name };
                }
            }
        },
        complete: function (e) {
            let grid = sourceScreen.get(`#${gridId}`).data("me");

            if (!grid) {
                grid = $(`#${gridId}`).data("me");
            }

            grid && grid.refresh();

            complete && complete(e, documentPopUp);
        },
        template,
        localization: {
            select: ll("SelectFile"),
            uploadSelectedFiles: ll("UploadFile")
        },
        select: function (e) {
            documentPopUp.container.mask();
            _.each(e.files, (file) => {
                let description = file.name;
                documentPopUp.get(`#${file.uid}_AttachmentDescription`).val(description);
                $.wait(250).then(function () {
                    documentPopUp.get(`#${file.uid}_AttachmentDescription`).val(description);
                    $.wait(250).then(function () {
                        documentPopUp.get(`#${e.files[0].uid}_AttachmentDescription`).focus();
                        documentPopUp.get(`#${file.uid}_AttachmentDescription`).val(description);
                        documentPopUp.container.unmask();
                    });
                });
            });
        },
        success: function (e) {
            success && success(e);
            documentPopUp.get(`#${e.files[0].uid}_AttachmentDescription`).attr("disabled", "disabled");
            alert({
                type: "success",
                header: ll("SaveSuccessful"),
                message: ll("SaveSuccessfulMessage").format(ll(successEntity))
            });
        },
        error: function (e) {
            documentPopUp.get(`#${e.files[0].uid}_AttachmentDescription`).attr("disabled", "disabled");
            alert({
                type: "danger",
                header: ll("SaveFailed"),
                message: ll("S3DocumentUploadError")
            });
        }
    });
    kendo.bind(documentPopUp.get("#UploadPopup .bind-label"), LocalizedLanguage);
    return false;
}

export function wellResize(pane, well) {
    var paneWell = pane;
    var targetWell = well;

    var tempWidth = paneWell.width() - 30;
    var paneWidth = tempWidth < 0 ? $(window).width() - 450 : tempWidth;
    var salesWidth = targetWell.width() + 6 + 2 + 20,
        wellWidths = salesWidth;

    var marginLeft;
    if (paneWidth < wellWidths) {
        marginLeft = (paneWidth - salesWidth) / 2;
        marginLeft = marginLeft < 10 ? 10 : marginLeft;
        targetWell.css("margin-left", marginLeft);
    } else {
        marginLeft = (paneWidth - wellWidths) / 2;
        marginLeft = marginLeft < 10 ? 10 : marginLeft;
        targetWell.css("margin-left", marginLeft);
    }
}

export function startEndNumbers(args) {
    var numericEntities = ["Order"],
        possiblyNumericEntities = ["Customer"];

    var entityType = args.entityType,
        entityNumber = entityType + "Number",
        popUpSearchTypeArgs = args.popUpSearchTypeArgs || {},
        lowerCaseType = entityType.toLowerCaseFirstLetter(),
        searchPopUpIcons = args.searchPopUpIcons,
        startPopUpIconClass = args.startPopUpIconClass,
        endPopUpIconClass = args.endPopUpIconClass,
        startingProperty = args.startingProperty || "Starting" + entityType + "Number",
        endingProperty = args.endingProperty || "Ending" + entityType + "Number",
        startingElem = args.startingElem,
        endingElem = args.endingElem,
        obs = args.observable,
        isNumeric = numericEntities.indexOf(entityType) != -1,
        isPossiblyNumeric = possiblyNumericEntities.indexOf(entityType) != -1;

    var getSortValue = function (value) {
        if (isNumeric) {
            return parseInt(value, 10);
        } else if (isPossiblyNumeric) {
            if (/^[0-9]+$/.test(value)) {
                return ("00000000000000000000" + value).substr(value.length);
            }
            return value.toLowerCase();
        } else {
            return value.toLowerCase();
        }
    };

    var setValue = function (value, isStarting) {
        var property = isStarting ? startingProperty : endingProperty,
            element = isStarting ? startingElem : endingElem;

        element.val(value);

        if (element.val() && element.val().trim()) {
            obs.set(property, element.val());
        } else {
            obs.set(property, null);
        }
    };

    var enableEndingNumber = function (enable) {
        if (enable) {
            endingElem.enable();
            $("." + endPopUpIconClass).enable();
        } else {
            endingElem.disable();
            $("." + endPopUpIconClass).disable();
        }
    };

    var changedNumber = function () {
        var startLiteral = startingElem.val(),
            startCompareVal = getSortValue(startLiteral),
            endLiteral = endingElem.val(),
            endCompareVal = getSortValue(endLiteral);

        if (!startCompareVal) {
            setValue(null, false);
            setValue(null, true);

            enableEndingNumber(false);
        } else if (!endCompareVal) {
            setValue(startLiteral, false);

            enableEndingNumber(true);
        } else if (endCompareVal < startCompareVal) {
            setValue(startLiteral, false);
            setValue(endLiteral, true);

            enableEndingNumber(true);
        }
    };

    popUpSearchTypeArgs.entityType = popUpSearchTypeArgs.entityType || entityType;
    popUpSearchTypeArgs.filter = popUpSearchTypeArgs.filter || entityType + "Number ne null";

    searchPopUpIcons.tie("click", function (e) {
        var elem = $(this);

        var sPopUp = searchPopUp({
            id: entityType + "NumberSearchListPopup",
            title: ll(entityType),
            types: [
                searchTypes.generate(popUpSearchTypeArgs)
            ],
            okClick: function () {
                var searchWindow = sPopUp.window;
                if (searchWindow.searchResults != null) {
                    var selectedValue = searchWindow.searchResults[entityNumber];

                    if (elem.hasClass(startPopUpIconClass)) {
                        setValue(selectedValue, true);
                    } else {
                        setValue(selectedValue, false);
                    }
                    changedNumber();
                }
            }
        });
    });

    endingElem.tie("change", function () {
        obs.set(endingProperty, $(this).val());
        changedNumber();
    });

    startingElem.tie("change", function () {
        obs.set(startingProperty, $(this).val());
        changedNumber();
    });

    enableEndingNumber(false);
}

export function setUDFEmptyValues(dto) {
    for (var key in dto) {
        if (key.indexOf("UDF_") > -1) {
            if (dto[key] == null || dto[key] == -1 || dto[key].Id == -1) {
                dto[key] = null;
            } else if (dto[key].Id != undefined) {
                dto[key] = dto[key].Id;
            }
        }
    }
    return dto;
}

export function startEndDateTimes(args) {
    var startingProperty = args.startingProperty,
        endingProperty = args.endingProperty,
        startingElem = args.startingElem,
        endingElem = args.endingElem,
        obs = args.observable;

    startingElem.data("kendoDateTimePicker").bind("change", function (e) {
        var startDate = startingElem.data("kendoDateTimePicker").value();
        var endDate = endingElem.data("kendoDateTimePicker").value();

        if (startDate) {
            if (endDate && startDate < endDate) {
                endingElem.enable();
            } else {
                endingElem.enable();
                endingElem.data("kendoDateTimePicker").value(startDate);
                obs.set(endingProperty, kendo.toString(startDate, "yyyy-MM-dd") + "T00:00:00Z");
            }
        } else {
            endingElem.data("kendoDateTimePicker").value(null);
            obs.set(endingProperty, null);
            endingElem.disable(true);
        }
    });

    endingElem.data("kendoDateTimePicker").bind("change", function (e) {
        var endDate = endingElem.data("kendoDateTimePicker").value();
        var startDate = startingElem.data("kendoDateTimePicker").value();

        if (endDate && endDate < startDate) {
            var start = startingElem.data("kendoDateTimePicker").value();
            obs.set(startingProperty, kendo.toString(endDate, "yyyy-MM-dd") + "T00:00:00Z");
            startingElem.data("kendoDateTimePicker").value(endDate);
            obs.set(endingProperty, kendo.toString(start, "yyyy-MM-dd") + "T00:00:00Z");
            endingElem.data("kendoDateTimePicker").value(start);
        } else {
            if (endDate) {
                obs.set(endingProperty, kendo.toString(endDate, "yyyy-MM-dd") + "T00:00:00Z");
            } else {
                obs.set(endingProperty, null);
            }
        }
    });
}

export function startEndDates(args) {
    var startingProperty = args.startingProperty,
        endingProperty = args.endingProperty,
        startingElem = args.startingElem,
        endingElem = args.endingElem,
        obs = args.observable;

    startingElem.data("kendoDatePicker").bind("change", function (e) {
        var startDate = startingElem.data("kendoDatePicker").value();
        var endDate = endingElem.data("kendoDatePicker").value();

        if (startDate) {
            if (endDate && startDate < endDate) {
                endingElem.enable();
            } else {
                endingElem.enable();
                endingElem.data("kendoDatePicker").value(startDate);
                obs.set(endingProperty, kendo.toString(startDate, "yyyy-MM-dd") + "T00:00:00Z");
            }
        } else {
            endingElem.data("kendoDatePicker").value(null);
            obs.set(endingProperty, null);
            endingElem.disable(true);
        }
    });

    endingElem.data("kendoDatePicker").bind("change", function (e) {
        var endDate = endingElem.data("kendoDatePicker").value();
        var startDate = startingElem.data("kendoDatePicker").value();

        if (endDate && endDate < startDate) {
            var start = startingElem.data("kendoDatePicker").value();
            obs.set(startingProperty, kendo.toString(endDate, "yyyy-MM-dd") + "T00:00:00Z");
            startingElem.data("kendoDatePicker").value(endDate);
            obs.set(endingProperty, kendo.toString(start, "yyyy-MM-dd") + "T00:00:00Z");
            endingElem.data("kendoDatePicker").value(start);
        } else {
            if (endDate) {
                obs.set(endingProperty, kendo.toString(endDate, "yyyy-MM-dd") + "T00:00:00Z");
            } else {
                obs.set(endingProperty, null);
            }
        }
    });
}

export function checkPasswordStrength(pwd) {
    var array = [];
    array.push(pwd.match(/[A-Z]/));
    array.push(pwd.match(/[a-z]/));
    array.push(pwd.match(/[0-9]/));
    array.push(pwd.match(/[^A-Za-z0-9]/));

    var sum = 0;
    $.each(array, function (index, match) {
        sum += match ? 1 : 0;
    });

    return sum;
}

export function isGuid(value) {
    var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
    var match = regex.exec(value);
    return match != null;
}

export function currentYear() {
    return (new Date()).getFullYear();
}


export function areGridColumnsEqual(columns1, columns2) {
    if (columns1.length != columns2.length) {
        return false;
    }

    var retVal = true;

    $.each(columns1, function (index, element) {
        if (element.field != columns2[index].field) {
            retVal = false;
        }
        if (element.hidden != columns2[index].hidden) {
            retVal = false;
        }
        if (element.template != columns2[index].template) {
            retVal = false;
        }
        if (element.title != columns2[index].title) {
            retVal = false;
        }
        if (element.width != columns2[index].width) {
            retVal = false;
        }
    });

    return retVal;
}

export function removeAttributesFromColumns(columns) {
    $.each(columns, function (index, element) {
        if (element.headerAttributes) {
            delete element.headerAttributes;
        }
        if (element.footerAttributes) {
            delete element.footerAttributes;
        }
        if (element.attributes) {
            delete element.attributes;
        }

    });
    return columns;
}

export function makeHamburgerMenuOpen(wantOpen) {
    var isOpen = $("#HamburgerMenu").width() > 0;
    $(".left-column-menu").hide();
    if ((isOpen && !wantOpen) || (!isOpen && wantOpen)) {
        $("#HamburgerMenu").hide();
        $(".hamburgerIcon").click();
    }
}

export function multiselectCodeSummary(data, codeSubProperty, maxListQty, separator, moreText) {
    var allItems = [];

    if (codeSubProperty) {
        $.each(data, function (index, codeList) {
            allItems.push(codeList[codeSubProperty].CodeNumber);
        });
    } else {
        $.each(data, function (index, codeList) {
            allItems.push(codeList.CodeNumber);
        });
    }

    if (allItems.length > 0) {
        var output = allItems.splice(0, maxListQty).join(separator);
        if (allItems.length > 0) {
            if (output.length > 12) {
                output = output.substring(0, 12);
                output += "... ";
            }
            output += moreText.replace("{0}", allItems.length);
        }
        return output;
    } else {
        return null;
    }
}

export function getCustomerInfo(entityType, id) {
    entityType = entityType || "Customer";
    id = id || -1;

    if (id > 0) {
        return ajax({ url: entityType + "/" + id });
    } else {
        return $.Deferred().resolve({
            d: { results: {} }
        });
    }
}

export function updateInfoOnCustomerSelect(args) {
    args = args ||
    {
        observable: observable({})
    };

    var obs = args.observable,
        data = args.data.Id ? args.data : { Id: -1 },
        type = args.type || "";

    var deferred = getCustomerInfo(args.entityType, data.Id);

    deferred.done(function (d) {
        var results = d.d.results;
        obs.set(type + "Attention", results.Attention ? results.Attention : null);
        if (type == "Billing") {
            obs.set("BillingName", results.CustomerName ? results.CustomerName : null);
        } else {
            obs.set(type + "BillingName", results.CustomerName ? results.CustomerName : null);
        }
        obs.set(type + "Address1", results.Address1 ? results.Address1 : null);
        obs.set(type + "Address2", results.Address2 ? results.Address2 : null);
        obs.set(type + "Address3", results.Address3 ? results.Address3 : null);
        obs.set(type + "City", results.City ? results.City : null);
        obs.set(type + "Region", results.Region ? results.Region : null);
        obs.set(type + "PostalCode", results.PostalCode ? results.PostalCode : null);
        obs.set(type + "Country", results.Country ? results.Country : null);
        obs.set(type + "Phone", results.Phone ? results.Phone : null);
        obs.set(type + "Ext", results.Ext ? results.Ext : null);
        obs.set(type + "Email", results.Email ? results.Email : null);
    });
}

export function calculateSegmentDescription(obs) {
    var jobDescription = "", componentDescription = "", modifierDescription = "";

    if (obs.JobId) {
        jobDescription = _.find(codes.Job, function (code) {
            return code.Id == obs.JobId;
        }).Value + " ";
    }

    if (obs.ComponentId) {
        componentDescription = _.find(codes.Component, function (code) {
            return code.Id == obs.ComponentId;
        }).Value + " ";
    }

    if (obs.ModifierId) {
        modifierDescription = _.find(codes.Modifier, function (code) {
            return code.Id == obs.ModifierId;
        }).Value;
    }

    var description = jobDescription + componentDescription + modifierDescription;
    obs.set("Description", description.trim());
}

export function getBooleanOption(optionNumber: string, defaultValue: boolean) {
    var option = _.find(user.companyData.Options, function (o) {
        return o.OptionNumber == optionNumber;
    });

    if (!option) {
        return defaultValue;
    }

    var value = option.Value.toLowerCase();
    return value === "true";
}

export function isOptionTrue(optionValue: string, defaultValue?: boolean) {
    if (!optionValue) {
        if (!defaultValue) {
            return false;
        } else {
            return defaultValue;
        }
    }

    let lowerCase = `${optionValue}`.toLowerCase();
    return lowerCase === "true";
}

export function getIntOption(optionNumber: string, defaultValue: number) {
    var option = _.find(user.companyData.Options, function (o) {
        return o.OptionNumber == optionNumber;
    });

    if (!option) {
        return defaultValue;
    }

    try {
        var parsedValue = parseInt(option.Value, undefined);
        return isNaN(parsedValue)
            ? defaultValue
            : parsedValue;
    } catch (e) {
        return defaultValue;
    }
}

export function getDateOption(optionNumber: string, defaultValue: Date): Date {
    var option = _.find(user.companyData.Options, function (o) {
        return o.OptionNumber == optionNumber;
    });

    if (!option || option.Value === "") {
        return defaultValue;
    }

    try {
        return new Date(option.Value);
    } catch (e) {
        return defaultValue;
    }
}

export function getOptionValue(optionNumber: string, defaultValue?: any) {
    if (defaultValue === undefined) {
        defaultValue = null;
    }

    var option = _.find(user.companyData.Options, { OptionNumber: optionNumber });

    return option
        ? option.Value
        : defaultValue;
}

export function inDayLightSavings() {
    var date = new Date();
    var january = new Date(date.getFullYear(), 0, 1);
    var july = new Date(date.getFullYear(), 6, 1);
    var standardTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());

    return date.getTimezoneOffset() < standardTimezoneOffset;
}

export function getLocale() {
    let locale = null;
    var companyData = $.parseJSON(localStorage.companyData);
    var languagePreference = _.find(companyData.UserPreferences, function (userPreference: any) {
        return userPreference.UserPreferenceNumber == "Language";
    });
    if (languagePreference) {
        locale = languagePreference.Value;
    } else if (companyData.Settings.DefaultLocale) {
        locale = companyData.Settings.DefaultLocale;
    }
    return locale;
}

export function generateAppointmentSpecialtyString(appointment: Appointment, limitToThree: boolean = false): string {
    appointment = appointment || {} as Appointment;
    appointment.AppointmentSpecialty = appointment.AppointmentSpecialty || [];

    let count = appointment.AppointmentSpecialty.length;
    if (count > 3 && limitToThree) {
        return ll("MoreThanThreeSpecialties");
    }

    if (count == 0) {
        return "---";
    }

    _.each(appointment.AppointmentSpecialty, (appointmentSpecialty) => {
        appointmentSpecialty.Specialty = appointmentSpecialty.Specialty || {} as Specialty;

        if (!appointmentSpecialty.Specialty.CodeNumber) {
            const match = _.find(codes.Specialty, (code: any) => {
                return appointmentSpecialty.SpecialtyId == code.Id;
            });

            appointmentSpecialty.Specialty.CodeNumber = match
                ? match.CodeNumber
                : null;
        }
    });

    let codeNumbers = _.map(appointment.AppointmentSpecialty, (appointmentSpecialty) => {
        return appointmentSpecialty.Specialty.CodeNumber;
    });

    return codeNumbers.join(", ");
}

export function generateAppointmentAddressString(appointment: Appointment, showAllFields: boolean = false): string {
    appointment = appointment || {} as Appointment;
    appointment.Order = appointment.Order || {} as Order;

    let addressLines = [],
        showAddress1 = showAllFields || getBooleanOption("ApptCellSiteAddress1", false),
        showAddress2 = showAllFields || getBooleanOption("ApptCellSiteAddress2", false),
        showAddress3 = showAllFields || getBooleanOption("ApptCellSiteAddress3", false),
        showCity = showAllFields || getBooleanOption("ApptCellSiteCity", false),
        showState = showAllFields || getBooleanOption("ApptCellSiteState", false),
        showZip = showAllFields || getBooleanOption("ApptCellSiteZip", false),
        showCountry = showAllFields || getBooleanOption("ApptCellSiteCountry", false);

    if (showAddress1 && appointment.Order.SiteAddress1) {
        var address1 = _.escape(appointment.Order.SiteAddress1);
        addressLines.push(address1);
    }

    if (showAddress2 && appointment.Order.SiteAddress2) {
        var address2 = _.escape(appointment.Order.SiteAddress2);
        addressLines.push(address2);
    }

    if (showAddress3 && appointment.Order.SiteAddress3) {
        var address3 = _.escape(appointment.Order.SiteAddress3);
        addressLines.push(address3);
    }

    if (showCity || showState || showZip) {
        let lineItems = [];

        if (showCity && appointment.Order.SiteCity) {
            var siteCity = _.escape(appointment.Order.SiteCity);
            lineItems.push(siteCity);
        }

        if (showState && appointment.Order.SiteRegion) {
            var siteRegion = _.escape(appointment.Order.SiteRegion);
            lineItems.push(siteRegion);
        }

        if (showZip && appointment.Order.SitePostalCode) {
            var sitePostalCode = _.escape(appointment.Order.SitePostalCode);
            lineItems.push(sitePostalCode);
        }

        addressLines.push(lineItems.join(", "));
    }

    if (showCountry && appointment.Order.SiteCountry) {
        addressLines.push(appointment.Order.SiteCountry);
    }

    if (addressLines.length <= 0) {
        return "---";
    }

    const lineBreak = "<br />";
    let retVal = addressLines.join(lineBreak);

    if (retVal.trim() == "") {
        return "---";
    }

    return retVal;
}

export function generateFirstOrderNoteString(appointment: Appointment) {
    let retVal = '---';
    if (appointment.Order && appointment.Order.OrderNote && appointment.Order.OrderNote.length > 0) {
        let sortedOrderNoteData = appointment.Order.OrderNote.sort((a, b) => {
            if (a.CreatedDateTime === b.CreatedDateTime) {
                return a.Id - b.Id;
            }
            return new Date(a.CreatedDateTime).getTime() - new Date(b.CreatedDateTime).getTime();
        });
        retVal = sortedOrderNoteData[0].Contents;
    }
    return retVal;
}

export function sortByNumberThenString(a, b) {
    let aIsNumber = !isNaN(Number(a)),
        bIsNumber = !isNaN(Number(b));
    if (aIsNumber && bIsNumber) {
        return a - b;
    } else if (aIsNumber) {
        return -1;
    } else if (bIsNumber) {
        return 1;
    } else {
        return a.localeCompare(b);
    }
}

export const travelDistanceEnabled = () => getBooleanOption("CalculateTravelDistanceFeature", false) && getBooleanOption("CalculateTravelDistanceEnabled", false);

export const useMetric = () => getBooleanOption("UseMetricUnits", false);

// eslint-disable-next-line react-hooks/rules-of-hooks
export const distanceUnits = () => ll(useMetric() ? "KilometersAbbreviation" : "MilesAbbreviation");

export const isItemInFilter = (dataItem: any, kendoFilter: kendo.data.DataSourceFilters & kendo.data.DataSourceFilterItem) => {
    if (kendoFilter.logic) {
        if (kendoFilter.logic === "and") {
            var result = true;

            _.forEach(kendoFilter.filters, (childFilter) => {
                result = result && isItemInFilter(dataItem, childFilter);
            });

            return result;
        } else if (kendoFilter.logic === "or") {
            var result = false;

            _.forEach(kendoFilter.filters, (childFilter) => {
                result = result || isItemInFilter(dataItem, childFilter);
            });

            return result;
        }
    } else {
        let value = _.get(dataItem, kendoFilter.field);

        switch (kendoFilter.operator) {
            case "eq":
                return `${value}`.toLowerCase() == `${kendoFilter.value}`.toLowerCase();
            case "neq":
                return `${value}`.toLowerCase() != `${kendoFilter.value}`.toLowerCase();
            case "isnull":
                return value == null;
            case "isnotnull":
                return value != null;
            case "lt":
                return value < kendoFilter.value;
            case "lte":
                return value <= kendoFilter.value;
            case "gt":
                return value > kendoFilter.value;
            case "gte":
                return value >= kendoFilter.value;
            case "startswith":
                return `${value}`.toLowerCase().startsWith(`${kendoFilter.value}`.toLowerCase());
            case "doesnotstartwith":
                return !`${value}`.toLowerCase().startsWith(`${kendoFilter.value}`.toLowerCase());
            case "endswith":
                return `${value}`.toLowerCase().endsWith(`${kendoFilter.value}`.toLowerCase());
            case "doesnotendwith":
                return !`${value}`.toLowerCase().endsWith(`${kendoFilter.value}`.toLowerCase());
            case "contains":
                return `${value}`.toLowerCase().contains(`${kendoFilter.value}`.toLowerCase());
            case "doesnotcontain":
                return !`${value}`.toLowerCase().contains(`${kendoFilter.value}`.toLowerCase());
            case "isempty":
                return value == "" || value == null;
            case "isnotempty":
                return value != "" && value != null;
        }

        return true;
    }
}

export function filter(data: any[], kendoFilter: kendo.data.DataSourceFilters & kendo.data.DataSourceFilterItem) {
    return kendoFilter
        ? _.filter(data, (dataItem) => isItemInFilter(dataItem, kendoFilter))
        : data;
}

export function sort(data: any[], kendoSort: kendo.data.DataSourceSortItem[]) {
    if (!kendoSort || kendoSort.length === 0) {
        return data;
    }

    let iteratees = _.map(kendoSort, ks => (dataItem: any) => `${_.get(dataItem, ks.field) || "---"}`.toLowerCase());
    let dirs: any[] = _.map(kendoSort, ks => ks.dir);

    return _.orderBy(data, iteratees, dirs);
}

export const isValidEmailAddress = (email: string): boolean => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   return re.test(String(email).trim().toLowerCase());
}
